export default __webpack_public_path__ + "static/media/play4.3a629df1.png";